import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      d: "M20.5 22H19v-3.5a7 7 0 0 0-4.4-6.5A7 7 0 0 0 19 5.5V2h1.5a1 1 0 0 0 0-2h-17a1 1 0 0 0 0 2H5v3.5A7 7 0 0 0 9.4 12 7 7 0 0 0 5 18.5V22H3.5a1 1 0 0 0 0 2h17a1 1 0 0 0 0-2M8.19 6.92a1 1 0 0 1 .89-.54h5.84A1 1 0 0 1 15.73 8a4.58 4.58 0 0 1-7.46 0 1 1 0 0 1-.08-1.08m-.27 11.71 3-2.94a1.55 1.55 0 0 1 2.07 0l3 2.94a1.36 1.36 0 0 1 .27 1.6A1.46 1.46 0 0 1 15 21H9a1.44 1.44 0 0 1-1.3-.76 1.35 1.35 0 0 1 .22-1.61"
    }, null, -1)
  ]));
}
const interfaceTimeHourGlass = { render };
export {
  interfaceTimeHourGlass as default,
  render
};
//# sourceMappingURL=interface-time-hour-glass.svg.js.map
